import "../../../../content/projects/openyard/openyard.css";
import * as React from 'react';
export default {
  React
};